export default {
  items: [
    {name: 'Submit', icon: 'fal fa-plus', url: '/submissions/add'},
    {name: 'My Projects', icon: 'fal fa-box', url: '/projects'},
    {name: 'My Samples', icon: 'fal fa-sack', url: '/samples'},
    {name: 'Orders', icon: 'fal fa-shopping-cart', url: '/orders'},
    {name: 'Reports', icon: 'fal fa-file-excel', url: '/reports'},
    {name: 'Results', icon: 'fal fa-vials', url: '/results', availableOnTokenAuth: true},
    //{name: 'API/Remote Access', icon: 'fal fa-server', url: '/api'},
    // {name: 'Products', icon: 'fal fa-cubes', url: '/products'},
    {name: 'Growers', icon: 'fal fa-hand-holding-seedling', url: '/customer-growers'},
    {name: 'Settings', icon: 'fal fa-cog', url: '/settings', availableOnTokenAuth: true},
  ]
}
